module.exports = __webpack_public_path__ + "static/img/71 (3).a2de1fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/71 (3).jpg
// module id = LY9B
// module chunks = 0